import AOS from "aos";
import "aos/dist/aos.css";
import Bowser from "bowser";

const detect_device = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const tablet_meta = `width=1440, initial-scale=${window.innerWidth / 1440}, maximum-scale=${window.innerWidth / 1440}, minimum-scale=${window.innerWidth / 1440}`;
  const normal_meta =
    "user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height";

  if (
    browser.getPlatformType() === "tablet" ||
    (browser.getPlatformType() === "desktop" && window.innerWidth < 1280) ||
    (browser.getPlatformType() === "mobile" && window.innerWidth > 767)
  ) {
    document
      .getElementById("viewport-meta")
      .setAttribute("content", tablet_meta);
  } else {
    document
      .getElementById("viewport-meta")
      .setAttribute("content", normal_meta);
  }
};

$(document).ready(function() {
  // detect_device();
  AOS.init({
    mirror: true
  });
  $.fancybox.defaults.btnTpl.fb =
    '<button data-fancybox-fb class="fancybox-button fancybox-button--fb" title="Facebook"></button>';
  $("body").on("click", "[data-fancybox-fb]", function() {
    window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(window.location.href) +
        "&t=" +
        encodeURIComponent(document.title),
      "",
      "left=0,top=0,width=600,height=300,menubar=no,toolbar=no,resizable=yes,scrollbars=yes"
    );
  });
  $.fancybox.defaults.iframe.tpl =
    '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen src=""></iframe>';
  $.fancybox.defaults.btnTpl.download =
    '<a target="_blank" download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg>' +
    "</a>";
  //TODO нужно заверстать кнопку на 11 строке
  $.fancybox.defaults.btnTpl.full =
    '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--full" title="fullscreen"></button>';
  $.fancybox.defaults.video.tpl = '<video class=\"fancybox-video\" src="{{src}}" playsinline muted preload controls loop></video>';

  $(".play-reel").fancybox({
    hash: false,
    buttons: ["close", "full"],
    gallery: false,
    beforeShow: function() {
      document.body.classList.add('video-popup');
    },
    afterClose: function() {
      document.body.classList.remove('video-popup');
    }
  });

  $("[data-fancybox][many-files]").fancybox({
    // 'showCloseButton': false,
    loop: true,
    animationEffect: "fade",
    wheel: false,
    slidesToShow: 1,
    scrolling: "no",
    mouseWheel: false,
    scrollOutside: false,
    buttons: ["download", "fb", "close", "full"],
    beforeShow: function() {
      $("html").css({ "overflow-y": "hidden" });
    },
    afterClose: function() {
      $("html").css({ "overflow-y": "visible" });
    },
    mobile: {
      beforeShow: function() {
        $("html").css({ "overflow-y": "visible" });
      }
    },
    onInit: function(instance) {
      if (instance.group.length === 1) {
        $(".fancybox-toolbar").addClass("no-arr");
      } else {
        $(".fancybox-toolbar").removeClass("no-arr");
      }
    }
  });
  $("[data-fancybox][one-file]").fancybox({
    // 'showCloseButton': false,
    loop: false,
    arrows: false,
    animationEffect: "fade",
    wheel: false,
    slidesToShow: 1,
    buttons: ["download", "fb", "close", "full"],
    beforeShow: function() {
      $("html").css({ "overflow-y": "hidden" });
    },
    afterClose: function() {
      $("html").css({ "overflow-y": "visible" });
    },
    mobile: {
      beforeShow: function() {
        $("html").css({ "overflow-y": "visible" });
      }
    },
    onInit: function(instance) {
      if (instance.group.length === 1) {
        $(".fancybox-toolbar").addClass("no-arr");
      } else {
        $(".fancybox-toolbar").removeClass("no-arr");
      }
    }
  });

  function fullscreen() {
    let frame = $("iframe");
    frame.hasClass("customFullScreen")
      ? frame.removeClass("customFullScreen")
      : frame.addClass("customFullScreen");
  }

  $(".mediaBox .item").on("click", function() {
    document.addEventListener("fullscreenchange", function() {
      fullscreen();
    });
    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        fullscreen();
      }
    });
    $("video source").each(function() {
      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .siblings(".fancybox-toolbar")
        .children("[data-fancybox-download]")
        .attr("href", $(this).attr("src"))
        .css("display", "inline-block");
    });
    $("iframe").each(function() {
      let href = $(this).attr("src");
      href = href.replace(/(media)\/([^/]+)\/(.+)/g, "$1/$2/download_$3");
      $(this)
        .parent()
        .parent()
        .parent()
        .siblings(".fancybox-toolbar")
        .children("[data-fancybox-download]")
        .attr("href", href)
        .css("display", "inline-block");
    });
  });
  String.prototype.toHHMMSS = function() {
    let sec_num = parseInt(this, 10); // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return (hours > 0 ? hours + ":" : "") + minutes + ":" + seconds;
  };

  let videos = document.getElementsByTagName("video");
  for (let video of videos) {
    video.addEventListener(
      "loadedmetadata",
      function() {
        let duration = video.duration.toString().toHHMMSS();
        // if (video.nextElementSibling) {
        //     video.nextElementSibling.innerHTML = duration;
        // }
      }.bind(video)
    );
  }

  setTimeout(function() {
    $(".title-item").click(function() {
      var height_h = $("header").outerHeight();
      $("html, body").animate(
        {
          scrollTop: $($(this).attr("href")).offset().top - height_h + "px"
        },
        {
          duration: 200,
          easing: "swing"
        }
      );
      return false;
    });
  }, 500);
  $(".title-item").click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(".title-item").removeClass("active");
      $(this).addClass("active");
    }
  });

  //------------------------
  var start_products = $(".start-products-slider");

  // if(start_products.length) {
  //     if ($(window).width() < 1024) {
  //         start_products.flickity({
  //             autoPlay: 5000,
  //             wrapAround: true,
  //             pageDots: true,
  //             prevNextButtons: false,
  //             pageDots: true
  //         });
  //     } else {
  //         start_products.flickity({
  //             autoPlay: 5000,
  //             wrapAround: true,
  //             pageDots: false,
  //             prevNextButtons: false,
  //         });
  //     }
  // }

  var imgHeight = $(".start-products-slider__image").height();

  $(".flickity-page-dots").css("top", imgHeight);

  var start_news = $(".start-news__list");

  if (start_news.length) {
    start_news.flickity({
      groupCells: 3,
      autoPlay: 5000,
      cellAlign: "left",
      pageDots: false,
      prevNextButtons: false
    });

    if ($(window).width() < 1024) {
      start_news.flickity("destroy");
    }
  }

  var inpdecorate = $(".inp-decorate--front");

  if (inpdecorate.length) {
    inpdecorate.styler({});
  }

  if ($(".inp-mobile").length) {
    $(".inp-mobile").inputmask({
      mask: "+ 999999999999999999999999999999999",
      placeholder: ""
    });
  }

  if ($(".signup").length) {
    $("body").on("keyup", function(e) {
      if (e.keyCode == 13) {
        $(".signup .btn-submit").trigger("click");
      }
    });
  }

  // Cart
  $(".js-cart-more-toggle").on("click", function(e) {
    let $this = $(this);

    e.preventDefault();

    $this
      .closest(".cart-item")
      .find(".cart-item__more")
      .slideToggle(250);
    $this.text(
      $this.text() == "Show details" ? "Hide details" : "Show details"
    );
  });

  $(".qty__minus").on("click", function(e) {
    e.preventDefault();

    var $input = $(this)
      .closest(".qty")
      .find(".qty__value");
    var value = parseInt($input.val());

    if (value > 1) {
      value = value - 1;
    } else {
      value = 0;
    }

    $input.val(value);
  });

  $(".qty__plus").on("click", function(e) {
    e.preventDefault();

    var $input = $(this)
      .closest(".qty")
      .find(".qty__value");
    var value = parseInt($input.val());

    if (value < 100) {
      value = value + 1;
    } else {
      value = 100;
    }

    $input.val(value);
  });

  // If safari add class
  if (
    navigator.userAgent.indexOf &&
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    document.body.className += " safari";
  }

  if (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)) {
    document.body.className += " mac-os";
  } else {
    document.body.className += " windows-os";
  }

  // Account sidebar
  if ($(".main-design__heading.video__block").length) {
    $(".main-design__heading.video__block .btn-watch").on("click", function() {
      let video = $(this)
        .closest(".main-design__heading.video__block")
        .find("video");
      let videoWrapper = $(this)
        .closest(".main-design__heading.video__block")
        .find(".video__block");

      video.trigger("play");
      videoWrapper.addClass("is-active");

      video.bind("ended", function() {
        videoWrapper.removeClass("is-active");
      });
    });
  }

  if ($(".cookie__big").length) {
    $("body, html").addClass("is-ovh");
  }

  if ($(".main-power.video__block").length) {
    $(".main-power.video__block .btn-watch").on("click", function() {
      var video = $(this)
        .closest(".main-power.video__block")
        .find("video");
      var videoWrapper = $(this)
        .closest(".main-power.video__block")
        .find(".video__block");

      video.trigger("play");
      videoWrapper.addClass("is-active");

      video.bind("ended", function() {
        videoWrapper.removeClass("is-active");
      });
    });
  }

  // Tabs
  var tabs = $(".tabs");

  function tabsNavActive(item) {
    var active = item.find(".active");
    if (active.length) {
      var activePos = active.position().left;
      var activeWidth = active.width();

      item.find(".tabs__nav-line").css({
        left: activePos,
        width: activeWidth
      });
    }
  }

  if (tabs.length) {
    tabs.each(function() {
      var tab = $(this).find(".tabs__nav");

      tab.append('<div class="tabs__nav-line"></div>');

      setTimeout(() => {
        tabsNavActive(tab);
      }, 2000);

      tab.find("a").on("shown.bs.tab", function(e) {
        tabsNavActive(tab);
      });
    });
  }

  var url = document.location.toString();

  if (url.match("#")) {
    $('.account__nav a[href="#' + url.split("#")[1] + '"]').tab("show");
  }

  // Change hash for page-reload
  $(".account__nav a").on("shown.bs.tab", function(e) {
    window.location.hash = e.target.hash;
  });

  $(".header__burger").on("click", function() {
    $(this).toggleClass("is-animated");
    $("body").toggleClass("menu--opened");
  });

  $(".cookie .btn").on("click", function() {
    $(this)
      .closest(".cookie")
      .hide();
  });

  // $('.cookie').hide();

  $("canvas + canvas + canvas")
    .parent()
    .remove();

  // Datepicker
  if ($(".inp-datepicker").length) {
    $(".inp-datepicker").datepicker({
      showOtherMonths: true,
      selectOtherMonths: true
    });
  }

  // Commented for back

  // var contacts_map = $('.contacts__map');

  // if(contacts_map.length) {
  //     var mainPosition = {
  //         lat: 42.502580,
  //         lng: 1.512780
  //     };
  //
  //     var iconMain = {
  //         url: '/assets/images/marker.svg',
  //         scaledSize: new google.maps.Size(12, 14),
  //     };
  //
  //     var mapOptions = {
  //         center: mainPosition,
  //         zoom: 13,
  //         disableDefaultUI: true,
  //         mapTypeControl: false,
  //         styles: [
  //             {
  //                 "featureType": "water",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#e9e9e9"
  //                     },
  //                     {
  //                         "lightness": 17
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "landscape",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#f5f5f5"
  //                     },
  //                     {
  //                         "lightness": 20
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "road.highway",
  //                 "elementType": "geometry.fill",
  //                 "stylers": [
  //                     {
  //                         "color": "#ffffff"
  //                     },
  //                     {
  //                         "lightness": 17
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "road.highway",
  //                 "elementType": "geometry.stroke",
  //                 "stylers": [
  //                     {
  //                         "color": "#ffffff"
  //                     },
  //                     {
  //                         "lightness": 29
  //                     },
  //                     {
  //                         "weight": 0.2
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "road.arterial",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#ffffff"
  //                     },
  //                     {
  //                         "lightness": 18
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "road.local",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#ffffff"
  //                     },
  //                     {
  //                         "lightness": 16
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "poi",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#f5f5f5"
  //                     },
  //                     {
  //                         "lightness": 21
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "poi.park",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#dedede"
  //                     },
  //                     {
  //                         "lightness": 21
  //                     }
  //                 ]
  //             },
  //             {
  //                 "elementType": "labels.text.stroke",
  //                 "stylers": [
  //                     {
  //                         "visibility": "on"
  //                     },
  //                     {
  //                         "color": "#ffffff"
  //                     },
  //                     {
  //                         "lightness": 16
  //                     }
  //                 ]
  //             },
  //             {
  //                 "elementType": "labels.text.fill",
  //                 "stylers": [
  //                     {
  //                         "saturation": 36
  //                     },
  //                     {
  //                         "color": "#333333"
  //                     },
  //                     {
  //                         "lightness": 40
  //                     }
  //                 ]
  //             },
  //             {
  //                 "elementType": "labels.icon",
  //                 "stylers": [
  //                     {
  //                         "visibility": "off"
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "transit",
  //                 "elementType": "geometry",
  //                 "stylers": [
  //                     {
  //                         "color": "#f2f2f2"
  //                     },
  //                     {
  //                         "lightness": 19
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "administrative",
  //                 "elementType": "geometry.fill",
  //                 "stylers": [
  //                     {
  //                         "color": "#fefefe"
  //                     },
  //                     {
  //                         "lightness": 20
  //                     }
  //                 ]
  //             },
  //             {
  //                 "featureType": "administrative",
  //                 "elementType": "geometry.stroke",
  //                 "stylers": [
  //                     {
  //                         "color": "#fefefe"
  //                     },
  //                     {
  //                         "lightness": 17
  //                     },
  //                     {
  //                         "weight": 1.2
  //                     }
  //                 ]
  //             }
  //         ]
  //     };
  //
  //     map = new google.maps.Map(document.getElementById('contacts-map'), mapOptions);
  //
  //     var marker = new MarkerWithLabel({
  //         position: mainPosition,
  //         map: map,
  //         icon: iconMain,
  //         labelContent: "<b>Forestal Technology Centre</b><br> Av. de Santa Coloma, 52<br> AD500 Andorra la Vella<br> Andorra<br> +376 860 664",
  //         labelAnchor: new google.maps.Point(-10, 100),
  //         labelClass: "marker-label",
  //     });
  // }

  // Footer select lang
  $("body").on("click", function() {
    $(".footer-lang__select").slideUp(250);
  });

  $(".footer-lang__current").on("click", function() {
    $(this)
      .parent()
      .find(".footer-lang__select")
      .slideDown(250);

    return false;
  });

  $(".footer-lang__select").on("click", function(e) {
    e.stopPropagation();
  });

  // Add to bag button
  $(".js-addtobag").on("click", function() {
    $(this).html('<span class="ico-added">Added</span>');
  });

  // Play video
  $(".btn-watch").on("click", function() {
    var video = $(this)
      .closest(".video__block")
      .find("video");
    var videoWrapper = $(this).closest(".video__block");

    video.trigger("play");
    videoWrapper.addClass("is-active");

    video.bind("ended", function() {
      videoWrapper.removeClass("is-active");
    });
  });

  // Email validation
  // $('input[type="email"]').on('keyup', function () {
  //     var $this = $(this);
  //
  //     $this.val($this.val().replace(/[^a-zA-Z0-9]/g, function () {
  //         return '';
  //     }));
  // });

  if ($(window).width() > 1024) {
    if (
      $(".account").length &&
      $(".account__nav").length &&
      $(".account__sidebar").length
    ) {
      $(".account__nav").pin({
        containerSelector: ".account__sidebar",
        padding: {
          top: 80,
          left: 0
        },
        minWidth: 768
      });
    }
  }

  var videoNews = document.querySelector(".news-video video");

  if (videoNews) {
    videoNews.onloadeddata = function() {
      videoNews.setAttribute("poster", " ");
    };
  }
});

// if ($('.checkout').length) {
//     let btnCheckout = $('.checkout-controls .btn');
//     let checkboxItem = $('.inp-groups__checkout .inp-group__checkbox');
//
//     checkboxItem.on('change', function () {
//         if ($('.inp-groups__checkout .inp-group__checkbox:checked').length == $('.inp-groups__checkout .inp-group__checkbox').length) {
//             btnCheckout.removeClass('is-disabled');
//             btnCheckout.removeClass('btn-gray');
//             btnCheckout.addClass('btn-green');
//             btnCheckout.removeAttr('disabled');
//         } else {
//             btnCheckout.addClass('is-disabled');
//             btnCheckout.removeClass('btn-green');
//             btnCheckout.addClass('btn-gray');
//             btnCheckout.attr('disabled', ' ');
//         }
//     });
// }

if ($(".footer-subscribe__form").length) {
  var btnSubmit = $(".footer-subscribe__btn");
  var checkboxItemFooter = $(
    ".footer-subscribe__checkbox .inp-group__checkbox"
  );

  checkboxItemFooter.on("change", function() {
    if (
      $(".footer-subscribe__checkbox .inp-group__checkbox:checked").length ==
      $(".footer-subscribe__checkbox .inp-group__checkbox").length
    ) {
      btnSubmit.removeClass("is-disabled");
      btnSubmit.removeAttr("disabled");
    } else {
      btnSubmit.addClass("is-disabled");
      btnSubmit.attr("disabled", " ");
    }
  });
}

$(window).on("load", function() {
  if ($(".customize-photo").length) {
    $(".customize-photo").pin({
      containerSelector: ".wrapper",
      padding: {
        top: 208,
        left: 0
      },
      minWidth: 768
    });
  }
});
